// SSR support
export const useAfp1 = () => (typeof document === 'undefined' ? '' : document.referrer);
